export default "__VITE_ASSET__CtOGswWW__"